<!-- Accessories Navbar -->
<div *ngIf="!mobile">
  <ion-segment
    mode="md"
    [value]="segmentSelected"
    (ionChange)="accessoriesSegmentChanged($event)"
    class="one3d-accessories-nav"
  >
    <ion-segment-button
      *ngFor="let tab of segments"
      class="one3d-accessories-nav-title"
      [ngClass]="{
        'one3d-accessories-nav-title-selected': tab.id == segmentSelected
      }"
      [value]="tab.id"
    > 
      <ion-label>{{
        tab.label  | titlecase 
      }}</ion-label>
    </ion-segment-button>
  </ion-segment>
  <kits *ngIf="segmentSelected == Tabs.KITS" [kits]="kits"></kits>
  <accessory-listing
    *ngIf="segmentSelected == Tabs.EXTERIOR"
    from="exterior"
    [accessoriesList]="exteriorAccessories"
  >
  </accessory-listing>
  <accessory-listing
    *ngIf="segmentSelected == Tabs.INTERIOR"
    from="interior"
    [accessoriesList]="interiorAccessories"
  >
  </accessory-listing>
</div>
<!-- Accessories Navbar -->
<div *ngIf="mobile" class="ion-hide-lg-up">
  <div class="one3d-acc-nav-bg">
    <ion-segment
      mode="md"
      [value]="segmentSelected"
      (ionChange)="accessoriesSegmentChanged($event)"
      class="one3d-accessories-nav"
    >
      <button
        class="one3d-accessories-nav-arrow"
        value=""
        *ngIf="mobile"
        (click)="closeAccessories()"
      >
        <ion-icon color="dark" name="chevron-back" size="small"></ion-icon>
      </button>
      <ion-segment-button
        *ngFor="let tab of segments"
        class="one3d-accessories-nav-title"
        [ngClass]="{
          'one3d-accessories-nav-title-selected': tab.id == segmentSelected
        }"
        [value]="tab.id"
      >
        <ion-label>{{
          tab.label | titlecase
        }}</ion-label>
      </ion-segment-button>
    </ion-segment>
  </div>
  <kits *ngIf="segmentSelected == Tabs.KITS" [kits]="kits"></kits>
  <accessory-listing
    *ngIf="segmentSelected == Tabs.EXTERIOR"
    from="exterior"
    [accessoriesList]="exteriorAccessories"
  >
  </accessory-listing>
  <accessory-listing
    *ngIf="segmentSelected == Tabs.INTERIOR"
    from="interior"
    [accessoriesList]="interiorAccessories"
  >
  </accessory-listing>
</div>
